var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navbar',{attrs:{"navigationLinks":_vm.navigationLinks},on:{"logout":_vm.onLogout}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }